import { axiosInstance } from "../../axiosInstance";

export class SitesApi {
  urlSites = "/sites";

  getMembersBySites(data) {
    return axiosInstance.get(`${this.urlSites}/${data.siteId}/members`);
  }
}
